<div class="flex flex-col">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-8">
        <app-configuration-card *ngFor="let configuration of configurations" [configuration]="configuration"></app-configuration-card>
    </div>
    </div>
